/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Modal, Tabs } from "react-bootstrap";

import { ModalContext } from "../../context/modal";
import { DefaultButton, MyModalBody } from "../../style/default";
import AdvancedConfig from "./advancedConfig";
import { Tab } from "./style";
import UserPropsConfig from "./userPropsConfig";
import { authApi } from "../../services/api";
import { toast } from "react-toastify";
import { TOASTIFY_OPTIONS } from "../../style/global";

function ModalAccountsEdit({ open, populateTable, data }) {
	const { handleOpenModal } = useContext(ModalContext);

	//CREATE USERPROPS CONFIG OBJECT
	const [userPropsData, setUserPropsData] = useState({});
	const [canGetUserPropsData, setGetUserPropsData] = useState(false);

	//CREATE ADVANCED CONFIG OBJECT
	const [advancedConfigData, setAdvancedConfigData] = useState({});
	const [canAdvancedConfigData, setGetAdvancedConfigData] = useState(false);

	useEffect(() => {
		if (
			Object.keys(advancedConfigData).length &&
			Object.keys(userPropsData).length
		) {
			const reqObj = {
				...userPropsData,
				...advancedConfigData,
			};
			handleEdit(reqObj);
		}
	}, [advancedConfigData]);

	const uploadProfilePhoto = async (obj) => {
		try {
			const formData = new FormData();
			formData.append("picture", obj.picture);
			formData.append("_id", obj._id);
			formData.append("uploadType", "company-pic");
			await authApi.post("/account/edit", formData);
		} catch (error) {
			return;
		}
	};

	const handleEdit = async (obj) => {
		try {
			if (Object.keys(obj).length) {
				const data = await authApi.post("/account/edit", obj);
				if (data.status === 200) {
					await uploadProfilePhoto(obj);
					toast.success(data.data.message, TOASTIFY_OPTIONS);
					populateTable();
					handleOpenModal();
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<Modal show={open} onHide={handleOpenModal} size="xl" backdrop="static">
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Editar: {data.name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<Tab>
						<Tabs>
							<Tabs eventKey="table" title="Configurações básicas">
								<UserPropsConfig
									data={data}
									updateTable={populateTable}
									setAllData={[userPropsData, setUserPropsData]}
									canGetData={[canGetUserPropsData, setGetUserPropsData]}
								/>
							</Tabs>
							<Tabs eventKey="chart" title="Configurações avançadas">
								<AdvancedConfig
									data={data}
									updateTable={populateTable}
									setAllData={[advancedConfigData, setAdvancedConfigData]}
									canGetData={[canAdvancedConfigData, setGetAdvancedConfigData]}
								/>
							</Tabs>
						</Tabs>
					</Tab>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<a href={`https://server.spread.chat/start-oauth/${data._id}`}>
					<DefaultButton>Autenticar: {data.name}</DefaultButton>
				</a>
				<DefaultButton
					onClick={() => {
						setGetAdvancedConfigData(true);
						setGetUserPropsData(true);
					}}
				>
					Editar
				</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { ModalAccountsEdit };
